import React from 'react'
import {config} from '../config'

const txdomain = config()['tourneyx-url']
const linodeurl = config()['linode-url'] //Chaitraly 05/mar/2024 :: TP-283 Jira card Load image from linode - reported issue for Daily big fish section angler profile image

const imgError = (event) => event.target.src = '/leaderboard/green28x.png'

export const getAvatar = (image, first_name, last_name, key) => {
  const name = `${first_name} ${last_name}`

  return image 
    ? <img key={`${key}avatar`}
        onError={imgError}
        src={`${txdomain}/app/lib/php/timthumb.php?src=${linodeurl}/angler_uploads/` + 
        image + '&amp;h=50&amp;w=50&amp;zc=1'} className="angler_avatar" alt=""/> 
    : <div key={`${key}`} className="ai-icon">{name.split(" ").map(n => n[0]).join("")}</div>
} 